import axios from 'axios';
import configs from '../configs/configs';
import { getCookies } from '../redux/cookieHandler';
import { ACCESS_TOKEN } from '../constants/cookieConstants';

const { domains, prefix, apiVersions } = configs.api || {};

export const apiCall = async ({
  serviceType,
  endpoint,
  method = 'GET',
  body = null,
  params = null,
  headers = {},
  onUploadProgress = null,
  cancelToken = null
}) => {
  const url = `${domains.main}${prefix}${serviceType}${apiVersions.version_one}${endpoint}`;

  const token = await getCookies(ACCESS_TOKEN);
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  try {
    const response = await axios({
      url,
      method,
      data: body,
      params,
      headers,
      onUploadProgress,
      cancelToken
    });

    return response;
  } catch (error) {
    throw error;
  }
};
